<template>
    <div>
        <header-page></header-page>
        <full-page :options="options" id="fullpage">
            <div class="section" id="section0">
                <div class="slide" id="menuChaud">
                </div>
            </div>
            <div class="TitleBottom"><a
                    @click="$vuetify.goTo('#welcome',{ duration:1000, offset:0, easing:'easeInOutCubic'})">
                <h1>
                    <v-icon :size="screenwidth" color="white">mdi-chevron-down</v-icon>
                    Menus chauds
                </h1>
            </a></div>
        </full-page>
        <div>
            <div class="backgroundGreen" id="welcome">
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-8 col-lg-8" style="background:#b3a3a4;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h2 class="display-5 bottomH2">Le plaisir d'un repas à table</h2>
                                        <h3 style="font-size:35px;font-family: 'Nunito', sans-serif;font-weight: bold">
                                            Croustillance vous suggère une sélection de menus chauds pour tous les <b>repas
                                            assis</b> qui marquent traditionnellement les grands événements de la vie :
                                            anniversaires, départs en retraite, mariages, baptêmes, communions, réunions
                                            de famille, etc.
                                        </h3>
                                        <p>
                                            Lors d’un repas assis, vos invités profitent pleinement des plaisirs d’un
                                            menu soigné, rythmé par au moins trois services. Confortablement attablés, vos
                                            convives prennent le temps d’échanger et de converser autour d’un repas hors
                                            norme.
                                        </p>
                                        <p>
                                            Pour faciliter votre choix, nous vous recommandons l’une de nos quatre formules,
                                            avec ou sans service, que nous pouvons bien sûr adapter en fonction de vos
                                            envies et de votre budget.
                                        </p>
                                        <p>
                                            Notre carte de menus chauds concentre le meilleur de Croustillance : une <b>cuisine
                                            inventive, colorée et goûteuse</b>, qui réjouira vos invités.
                                        </p>
                                        <p>
                                            Parce qu’un repas, c’est bien plus qu’un menu, nous pouvons également vous
                                            accompagner dans la recherche du lieu de réception, le choix des vins et des
                                            apéritifs.
                                        </p>


                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/menus-chauds/menu-traiteur-epinal.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h3 class="display-6 titleSpacer" style="background-color: #7d2c6fb3;">Nos
                                            formules menus chauds</h3>
                                        <p>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/menu-sotre.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir le menu SOTRE</span>
                                            </a>
                                        </div>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/menu-chamois.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir le menu CHAMOIS</span>
                                            </a>
                                        </div>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/menu-lynx.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir le menu LYNX</span>
                                            </a>
                                        </div>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/menu-tetras.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir le menu TETRAS</span>
                                            </a>
                                        </div>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/menu-pate-lorrain.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir le menu PATÉ LORRAIN</span>
                                            </a>
                                        </div>
                                        </p><br><br>
                                        <h3 class="display-6 titleSpacer" style="background-color: #7d2c6fb3;">La carte
                                            des petits plats</h3>
                                        <p>
                                        <div class="btns-action sr-up-td3 text-primary">
                                            <a href="pdf/carte-petits-plats.pdf" target="_blank"
                                               class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                <span class="text">Découvrir la carte des petits plats</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="media-row">
                <div class="row backgroundGreen">
                    <div class="col-12 col-md-4 col-lg-4" style="background-image: url('img/menus-chauds/choux-farcis.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="img/menus-chauds/choux-farcis.jpg" alt="Vosges terroir"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('img/menus-chauds/choux-farcis.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                            <div class="media-body align-top">
                                <div class="desc">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-color: #99a411">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <h3 class="display-6">La convivialité avant tout</h3>
                                    <p>
                                        Avec les repas chauds de Croustillance, profitez de vos invités sans vous soucier du reste ! On vous propose même d’assurer le service.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('img/menus-chauds/menu-dessert.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="img/menus-chauds/menu-dessert.jpg" alt="Les desserts Croustillance"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('img/menus-chauds/menu-dessert.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                            <div class="media-body align-top">
                                <div class="desc">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="media-row">
                <div class="row backgroundGreen">
                    <div class="col-12 col-md-4 col-lg-4" style="background-color:#3b869d;">
                        <div class="item media text-white alignLeft">

                            <div class="media-body align-top">
                                <div class="desc">
                                    <h3 class="display-6">Adeptes du terroir</h3>
                                    <p>
                                        Croustillance est le seul traiteur labellisé Vosges Terroir. Une option que vous pouvez choisir afin de manger local, frais et de saison.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('img/menus-chauds/dressage-table.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="img/menus-chauds/dressage-table.jpg" alt="Dressage de table par Croustillance"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('img/menus-chauds/dressage-table.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                            <div class="media-body align-top">
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('img/menus-chauds/cookie-dessert.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="img/menus-chauds/cookie-dessert.jpg" alt="Les desserts Croustillance"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('img/menus-chauds/cookie-dessert.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                            <div class="media-body align-top">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-page></footer-page>
    </div>

</template>

<script>
    import HeaderPage from './headerPage'
    import FooterPage from './footerPage'

    export default {
        name: 'repasPar',
        components: {
            HeaderPage,
            FooterPage
        },
        data() {
            return {
                options: {
                    licenseKey: 'A32C7F42-F0FE4A04-AAB7E182-AB1F9C8B',
                    navigation: false,
                    scrollBar: true,
                    autoScrolling: false,
                    fitToSection: false
                }
            }
        },
        methods: {
            afterLoad() {
                console.log('After load')
            },
        },
        computed: {
            screenwidth() {
                if (screen.width > 400) {
                    return 70
                } else {
                    return 30
                }
            }
        },
        created() {
            document.getElementsByTagName('meta')["description"].content = "Le traiteur Croustillance vous propose une sélection de menus chauds pour tous les repas assis qui marquent les grands événements de votre vie.";
            document.title = "Menus chauds pour réceptions privées | Traiteur Croustillance";
        }
    }
</script>

<style>
    #menuChaud {
        background: url('/img/menus-chauds/menus-traiteur.jpg') no-repeat center center;
        padding: 0 0 0 0;
        background-size: cover;
    }
</style>